export var getNavigateCallback = function (_a) {
    var callbackFinallyLoad = _a.callbackFinallyLoad, dispatch = _a.dispatch, setLoadingStopAction = _a.setLoadingStopAction;
    return function () {
        if (callbackFinallyLoad) {
            return callbackFinallyLoad({
                loadProductsStopAction: setLoadingStopAction,
            });
        }
        return dispatch(setLoadingStopAction());
    };
};
